import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { resetBalanceParams, AdminCustomerAccountFacade } from '@coin-depo-core/admin-customer-account';

@Injectable()
export class AdminCustomerAccountServiceStubFacade implements AdminCustomerAccountFacade {

  getAssetUserTxt(clientId: string): Observable<Blob> {
    const blob = new Blob([], { type: 'text/plain' });
    return of(blob);
  }

  userWalletRebalance(params: resetBalanceParams): Observable<any> {
    return of({ status: 'success', msg: 'Stub: action skipped' });
  }
}
